 
<template>

    <div id="WrikeReportData">
<nav class="navbar is-primary">
  <div class="navbar-brand">
     <p class="navtitle">{{title}}</p>
     </div>
    
        <div class="navbar-menu is-active" >
        <div class="navbar-start">
           
        </div>
        <div class="navbar-end">
             <div class="navbar-item">
        <div class="field is-grouped">
            <p class="control report_create_date">Report created on: {{report_info.created_date}}</p>
     </div>
        </div>
    
            <img  class="navlogo" src="@/assets/sie-logo-claim-white-rgb.png"/>
        </div>
    </div>
     </nav>


             <div class="loading" v-if="loading">
        <b-loading :is-full-page="isFullPage" :active.sync="loading" :can-cancel="true"></b-loading>
        </div>
<!-- report -->

 {{message}}
 <section class="section" id="report_page" v-if="report_loaded">
<!-- top row KPIs -->
<div class="report_created_date_printing">Report created on: {{report_info.created_date}}<br></div>

<div >
<div class="columns" >
    <div class="column is-centered">
          <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                        Total Tasks
                    </p>
                </header>
                <div class="card-content has-text-centered">
                    <div class="content is-size-1"> 
                        {{report_total_tasks_metric}}
                    </div>
                </div>
            </div>
    </div>
    <div class="column is-centered">
          <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                        Active Tasks
                    </p>
                </header>
                <div class="card-content has-text-centered">
                    <div class="content is-size-1"> 
                        {{report_active_tasks_metric}}
                    </div>
                </div>
            </div>
    </div>
    <div class="column is-centered">
          <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                        New Tasks
                    </p>
                </header>
                <div class="card-content has-text-centered">
                    <div class="content is-size-1"> 
                        {{report_new_tasks_metric}}
                    </div>
                </div>
            </div>
    </div>
    <div class="column is-centered">
          <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                        Overdue Tasks
                    </p>
                </header>
                <div class="card-content has-text-centered">
                    <div class="content is-size-1"> 
                        {{report_overdue_tasks_metric}}
                    </div>
                </div>
            </div>
    </div>
 <div class="column is-centered">
          <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                         Task Completion Progress
                    </p>
                </header>
                <div class="card-content has-text-centered">
                    <div class="content is-size-1"> 
                        {{report_task_completion_progress_metric}}%
                    </div>
                </div>
            </div>
    </div>
</div>


<!-- site overview items -->
<div class="columns vertical-printing">
  <div class="column">   
                  <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                Site Status Overview
                    </p>
                </header>
                       <div class="card-content has-text-centered is-chart">
                        <div class="content"> 
                    <ReactiveChart :chart="report_site_status_overview_pie_chart"></ReactiveChart> 
                    </div>
                </div>
            </div></div>
  <div class="column">   
                  <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                Tasks by Assignee
                    </p>
                </header>
                     <div class="card-content has-text-centered is-chart">
                        <div class="content"> 
                    <ReactiveChart :chart="report_tasks_by_assignee_histogram_chart"></ReactiveChart> 
                </div>
                </div>
            </div></div>
</div>

<div class="pagebreak"></div>
<!-- service reports items -->
<div class="columns vertical-printing" v-if="report_options.include_wrike_service_reports">
  <div class="column is-three-fifths"> 
            <div class="card datatable">
                <header class="card-header">
                    <p class="card-header-title">
                Service Reports
                    </p>
                </header>
                <div class="card-content datatable">
                    <div class="content"> 
                           <b-table :data="report_service_reports_table" narrowed>
                                <template slot-scope="props">
                                <b-table-column field="task_id" label="Task ID" >{{ props.row.permalink.split("id=")[1] }}</b-table-column>    
                                <b-table-column field="task_name" label="Task Name" >{{ props.row.title }}</b-table-column>           
                                <b-table-column field="status" label="Status" ><span v-bind:style="{ color: props.row.customStatus.hex}">&#9632;</span>&nbsp;{{ props.row.customStatus.name }}</b-table-column>
                                <b-table-column field="author" label="Author" >{{ props.row.authorIds }}</b-table-column>
                                <b-table-column field="assignee" label="Assignee" >{{ props.row.responsibleIds }}</b-table-column>            
                                <b-table-column field="creation_date" label="Creation Date" >{{ props.row.createdDate }}</b-table-column>
                                <b-table-column field="due_date" label="Due Date" >{{ props.row.dueDate }}</b-table-column>
                                <b-table-column field="completion_date" label="Completion Date" >{{ props.row.completedDate }}</b-table-column>            
                                <b-table-column field="get_details" label="Get details" ><a @click="get_task_data(props.row.id)">Get details</a></b-table-column>
                                </template>
                         </b-table>
                    </div>
                </div>
            </div>
        </div>
  <div class="column is-centered">   
             <div class="card calendar-card">
                <header class="card-header">
                    <p class="card-header-title">
                         Onsite Service Completed
                    </p>
                </header>
                <div class="card-content has-text-centered">
                    <div class="content"> 
                         <Calendar ref="calendar_chart" :attributes='report_onsite_service_completed_calendar_chart'/>
                    </div>
                </div>
            </div>
         </div>
</div>

<div class="pagebreak"></div>
<!-- navigator items -->
<div class="columns vertical-printing"  v-if="report_options.include_wrike_navigator_items">
  <div class="column is-three-fifths"> 
           <div class="card datatable">
                <header class="card-header">
                    <p class="card-header-title">
                         Navigator Items
                    </p>
                </header>
                <div class="card-content datatable">
                    <div class="content"> 
                           <b-table :data="report_navigator_items_table" narrowed scrollable>
                                <template slot-scope="props">
                                <b-table-column field="task_id" label="Task ID" >{{ props.row.permalink.split("id=")[1] }}</b-table-column>         
                                <b-table-column field="task_name" label="Task Name" >{{ props.row.title }}</b-table-column>            
                                <b-table-column field="status" label="Status" ><span v-bind:style="{ color: props.row.customStatus.hex}">&#9632;</span>&nbsp;{{ props.row.customStatus.name }}</b-table-column>
                                <b-table-column field="author" label="Author" >{{ props.row.authorIds }}</b-table-column>
                                <b-table-column field="assignee" label="Assignee" >{{ props.row.responsibleIds }}</b-table-column>            
                                <b-table-column field="creation_date" label="Creation Date" >{{ props.row.createdDate }}</b-table-column>
                                <b-table-column field="due_date" label="Due Date" >{{ props.row.dueDate }}</b-table-column>
                                <b-table-column field="completion_date" label="Completion Date" >{{ props.row.completedDate }}</b-table-column>            
                                <b-table-column field="get_details" label="Get details" ><a @click="get_task_data(props.row.id)">Get details</a></b-table-column>
                                </template>
                           </b-table>
                    </div>
                </div>
            </div>
                </div>
  <div class="column"> 
            <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                         Navigator Tasks Overview
                    </p>
                </header>
                          <div class="card-content has-text-centered is-chart">
                        <div class="content"> 
                        <ReactiveChart :chart="report_navigator_tasks_overview_pie_chart"></ReactiveChart>
                </div>
                </div>
            </div>
      
      </div>
</div>
<div class="pagebreak"></div>
<!-- energy consumption items -->
<div class="columns vertical-printing" v-if="report_options.include_wrike_energy_consumption_items">
  <div class="column is-three-fifths">
         <div class="card">
                <header class="card-header datatable">
                    <p class="card-header-title">
                         Energy Consumption Items
                    </p>
                </header>
                <div class="card-content datatable">
                    <div class="content"> 
                          <b-table :data="report_energy_consumption_items_table" narrowed>
                            <template slot-scope="props">
                            <b-table-column field="task_id" label="Task ID" >{{ props.row.permalink.split("id=")[1] }}</b-table-column>     
                            <b-table-column field="task_name" label="Task Name" >{{ props.row.title }}</b-table-column>           
                            <b-table-column field="status" label="Status" ><span v-bind:style="{ color: props.row.customStatus.hex}">&#9632;</span>&nbsp;{{ props.row.customStatus.name }}</b-table-column>
                            <b-table-column field="author" label="Author" >{{ props.row.authorIds }}</b-table-column>
                            <b-table-column field="assignee" label="Assignee" >{{ props.row.responsibleIds }}</b-table-column>            
                            <b-table-column field="creation_date" label="Creation Date" >{{ props.row.createdDate }}</b-table-column>
                            <b-table-column field="due_date" label="Due Date" >{{ props.row.dueDate }}</b-table-column>
                            <b-table-column field="completion_date" label="Completion Date" >{{ props.row.completedDate }}</b-table-column>            
                            <b-table-column field="get_details" label="Get details" ><a @click="get_task_data(props.row.id)">Get details</a></b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
                  </div>
  <div class="column  ">   
             <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                         Energy Consumption Tasks by Assignee
                    </p>
                </header>
                          <div class="card-content has-text-centered is-chart">
                        <div class="content"> 
                         <ReactiveChart :chart="report_energy_consumption_tasks_by_assignee_histogram_chart"></ReactiveChart>
                    </div>
                    </div>
           
            </div>
        </div>
</div>

<div class="pagebreak"></div>
<!-- account review items -->
<div class="columns vertical-printing"  v-if="report_options.include_wrike_account_manager_items">
  <div class="column is-three-fifths"> 
             <div class="card datatable">
                <header class="card-header">
                    <p class="card-header-title">
                         Account Review
                    </p>
                </header>
                <div class="card-content datatable">
                    <div class="content"> 
                        <b-table :data="report_account_review_items_table" narrowed>
                            <template slot-scope="props">
                            <b-table-column field="task_id" label="Task ID" >{{ props.row.permalink.split("id=")[1] }}</b-table-column>  
                            <b-table-column field="task_name" label="Task Name" >{{ props.row.title }}</b-table-column>              
                            <b-table-column field="status" label="Status" ><span v-bind:style="{ color: props.row.customStatus.hex}">&#9632;</span>&nbsp;{{ props.row.customStatus.name }}</b-table-column>
                            <b-table-column field="author" label="Author" >{{ props.row.authorIds }}</b-table-column>
                            <b-table-column field="assignee" label="Assignee" >{{ props.row.responsibleIds }}</b-table-column>            
                            <b-table-column field="creation_date" label="Creation Date" >{{ props.row.createdDate }}</b-table-column>
                            <b-table-column field="due_date" label="Due Date" >{{ props.row.dueDate }}</b-table-column>
                            <b-table-column field="completion_date" label="Completion Date" >{{ props.row.completedDate }}</b-table-column>            
                            <b-table-column field="get_details" label="Get details" ><a @click="get_task_data(props.row.id)">Get details</a></b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
         </div>
    <div class="column  ">  
          <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                         Account Tasks by Assignee
                    </p>
                </header>
                      <div class="card-content has-text-centered is-chart">
                        <div class="content"> 
                         <ReactiveChart :chart="report_account_tasks_by_assignee_histogram_chart"></ReactiveChart>
                    </div>
                </div>
            </div>
        </div>
  <div class="column"> 
         <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                         Account Tasks Overview
                    </p>
                </header>
                        <div class="card-content has-text-centered is-chart">
                        <div class="content"> 
                       <ReactiveChart :chart="report_account_tasks_overview_pie_chart"></ReactiveChart>
                    </div>
                    </div>
              
            </div> 
        </div>
</div>
</div>


<div class="pagebreak"></div>
<!-- Apogee Hea;th Check Section-->
<div v-show="report_options.include_apogee_health_check_report">
<div class="columns vertical-printing" v-if="report_options.include_apogee_health_check_panel_summary">
  <div class="column">
         <div class="card">
                <header class="card-header datatable">
                    <p class="card-header-title">
                         Primary Controllers Summary
                    </p>
                </header>
                <div class="card-content datatable">
                    <div class="content"> 
                          <b-table :data="apogee_health_check_panel_summary_table" narrowed>
                            <template slot-scope="props">
                            <b-table-column field="Panel" label="Panel" >{{ props.row.Panel}}</b-table-column>     
                            <b-table-column field="Quantity" label="Quantity" >{{ props.row.Quantity }}</b-table-column>           
                            <b-table-column field="Introduction Date" label="Introduction Date" >{{ props.row['Introduction Date']}}</b-table-column>     
                            <b-table-column field="Retirement Date" label="Retirement Date" >{{ props.row['Retirement Date'] }}</b-table-column>    
                               <b-table-column field="Service Support Ends" label="Service Support Ends" >{{ props.row['Service Support Ends']}}</b-table-column>     
                            <b-table-column field="Reference Key Below" label="Reference Key Below" >{{ props.row['Reference Key Below'] }}</b-table-column>                             

                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
                  </div>
  <div class="column">   
             <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                         Primary Controllers Graph
                    </p>
                </header>
                          <div class="card-content has-text-centered is-chart">
                        <div class="content"> 
                         <ReactiveChart :chart="apogee_health_check_panel_summary_graph"></ReactiveChart>
                    </div>
                    </div>
           
            </div>
        </div>
</div>
<div class="pagebreak"></div>
<div class="columns vertical-printing" v-if="report_options.include_apogee_health_check_points_summary">
  <div class="column">
         <div class="card">
                <header class="card-header datatable">
                    <p class="card-header-title">
                         Points Summary
                    </p>
                </header>
                <div class="card-content datatable">
                    <div class="content"> 
                          <b-table :data="apogee_health_check_points_summary_table" narrowed>
                            <template slot-scope="props">
                            <b-table-column field="Description" label="Description" >{{ props.row.description}}</b-table-column>     
                            <b-table-column field="System Total" label="System Total" >{{ props.row.total }}</b-table-column>           
                             <b-table-column field="Details" label="Details" >
                                <a v-if=" props.row.extra_details" @click="get_point_summary_details(props.row.description)">Get details</a>
                                </b-table-column>                       
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
                  </div>
  <div class="column">   
             <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                         Points Summary Graph
                    </p>
                </header>
                          <div class="card-content has-text-centered is-chart">
                        <div class="content"> 
                         <ReactiveChart :chart="apogee_health_check_points_summary_graph"></ReactiveChart>
                    </div>
                    </div>
           
            </div>
        </div>
</div>
<div class="pagebreak"></div>
<div class="columns vertical-printing" v-if="report_options.include_apogee_health_check_alarm_summary">
  <div class="column">
         <div class="card">
                <header class="card-header datatable">
                    <p class="card-header-title">
                         Point Alarm Summary for {{report_options.apogee_health_check_alarm_summary_period}}
                    </p>
                </header>
                <div class="card-content datatable">
                    <div class="content"> 
                          <b-table :data="apogee_health_check_alarm_summary_table" narrowed>
                            <template slot-scope="props">
                            <b-table-column field="Description" label="Description" >{{ props.row.description}}</b-table-column>     
                            <b-table-column field="System Total" label="System Total" >{{ props.row.total }}</b-table-column>           
                             <b-table-column field="Details" label="Details" >
                                <a v-if=" props.row.extra_details" @click="get_alarm_summary_details(props.row.description)">Get details</a>
                                </b-table-column>                       
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
                  </div>
  <div class="column">   
             <div class="card">
                <header class="card-header">
                    <p class="card-header-title">
                         Top Alarms for {{report_options.apogee_health_check_alarm_summary_period}} (by total alarm transitions)
                    </p>
                </header>
                          <div class="card-content has-text-centered is-chart">
                        <div class="content"> 
                         <ReactiveChart :chart="apogee_health_check_alarm_summary_graph"></ReactiveChart>
                    </div>
                    </div>
           
            </div>
        </div>
</div>

</div>
 </section>
<!-- end of report -->

 <!-- task card -->
      
    <!-- task card -->
   <b-modal v-model="taskModalActive" :active.sync="taskModalActive"  :autofocus="true">
            
            <div v-if="task_data_loaded">
               <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{task_data_formatted.data[0].title}}</p>
                        <button type="button" class="delete" @click="taskModalActive=false"/>
            </header>
            <div class="modal-card-body">
                <div class="content">
              <p><strong><span v-bind:style="{ color: task_data_formatted.data[0].customStatus.hex}">&#9632;</span>&nbsp;{{task_data_formatted.data[0].customStatus.name}}</strong>&nbsp;&nbsp;
              <strong>Created by:</strong> {{task_data_formatted.data[0].authorIds[0]}}&nbsp;<small>{{task_data_formatted.data[0].createdDate}}</small>&nbsp;
              <strong>Assignees: </strong>{{task_data_formatted.data[0].responsibleIds}}
              </p>
                <hr>    
               <p v-html="task_data_formatted.data[0].description"></p>

              <hr>
            <div class="attachments_table">
               <b-table :data="task_data_formatted.attachments" narrowed>
              <template slot-scope="props">
                <b-table-column field="id" label="Attachments">  <div @click="downloadAttachment(props.row.id)">  <img :src="`data:image/png;base64,${props.row.preview_base64}`" /> </div></b-table-column>
                <b-table-column field="name" label="Filename" >{{ props.row.name }}</b-table-column>
                <b-table-column field="download" label="Download" > 
                  <b-button type="is-dark"  size="is-small" icon-right="download" @click="downloadAttachment(props.row.id)"/>
                  </b-table-column>
                 <b-table-column field="createdDate" label="Uploaded Date">{{ props.row.createdDate }}</b-table-column>
            </template>
            </b-table>
            </div>
             

             <hr>

             <br>
             
             <p><b>Comments</b></p>

             <div class="box" v-for="comment in task_data_formatted.comments" :key="comment.id">
                <article class="media">
                    <div class="media-left">
                    <figure class="image is-64x64">
                        <img src="https://bulma.io/images/placeholders/64x64.png" alt="Image">
                    </figure>
                    </div>
                    <div class="media-content">
                    <div class="content">
                        <p>
                        <strong>{{comment.authorId}}</strong>&nbsp;<small>{{comment.createdDate}}</small>
                         </p>
                        <p v-html="comment.text"></p>
                        <div v-for="attachment in comment.attachments" :key="attachment.id" @click="downloadAttachment(attachment.id)">  <img :src="`data:image/png;base64,${attachment.preview_base64}`" /> </div>
               
                    </div>
                    </div>
                </article>
                </div>
                 
                </div>
            </div>
        </div>   

            </div>
            </b-modal>
     

<!-- MODALS -->
  <b-modal v-model="passwordModalActive" :active.sync="passwordModalActive" :can-cancel="canCancelModal" :autofocus="true">
                <div class="modal-card">
                    <section class="modal-card-body">
                        <b-field label="Password">
                            <b-input type="password"
                            id="password_input"
                            v-on:keyup.enter.native="submitPassword"
                            v-model="password"
                                password-reveal>
                            </b-input>
                        </b-field>     
                        </section>          
                        <b-button label="Submit" type="is-primary" @click="submitPassword"/>   
                </div>

        </b-modal>

  <b-modal v-model="panelIssuesPointsTotalsModalActive" :active.sync="panelIssuesPointsTotalsModalActive" can-cancel autofocus>
        <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Field Panel Point Summary</p>
            <button type="button" class="delete" @click="panelIssuesPointsTotalsModalActive=false"/>
        </header>
    <div class="modal-card-body">
        <div class="modal-card-content" >
<p>The BAS system is made up of sensors, contacts, setpoints and many other values each of which are characterized as a "point". A point generally represents a data value which controls or is monitored through the system.</p>
<p>The following refers to all points which are "hardwired". A hardwired point is a physical sensor or other device connected by a physical electrical wire to its associated BAS control panel. Points which report as "Failed", "Out of Service" or "Overridden" should be investigated for corrective action. </p>
            <b-table :default-sort="['total_points_issue','desc']" style="max-height:None" :data="report_data.automation_health_report.point_summary_details.panel_issues_points_totals_dict_array" narrowed paginated>
                    <template slot-scope="props">
                        <b-table-column  sortable searchable field="panel_name" label="Panel Name">{{props.row.panel_name}}</b-table-column>
                        <b-table-column  sortable searchable field="total_points_issue" label="Total Issues" >{{ props.row.total_points_issue }}</b-table-column>
                        <b-table-column  sortable searchable field="total_points_failed" label="Failed" >{{ props.row.total_points_failed }}</b-table-column>
                        <b-table-column  sortable searchable field="total_points_in_OPER" label="OPER" >{{ props.row.total_points_in_OPER }}</b-table-column>
                        <b-table-column sortable searchable  field="total_points_out_of_service" label="Out of Service" >{{ props.row.total_points_out_of_service }}</b-table-column>
                    </template>
            </b-table>
        </div>
        </div>
    </div>
 </b-modal>

  <b-modal v-model="pointsOPERDetailModalActive" :active.sync="pointsOPERDetailModalActive" can-cancel >
        <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Hardwire Points in OPER Priority</p>
            <button type="button" class="delete" @click="pointsOPERDetailModalActive=false"/>
        </header>
    <div class="modal-card-body">
        <div class="modal-card-content" >
<p>The following lists all Apogee field panel hardwired physical points which were reported to the system as In OPER priority.
     Points are generally placed into manual operation in order to override program (automatic operation).  "OPER" refers to an override through software (by the operator). </p>
     <p>Note: Only points and not subpoints are counted in summary total.</p>
            <b-table default-sort="point_name" style="max-height:None" :data="report_data.automation_health_report.point_summary_details.OPER_points_array" narrowed paginated> 
                    <template slot-scope="props">
                        <b-table-column sortable searchable field="panel" label="Panel Name">{{props.row.panel}}</b-table-column>
                        <b-table-column  sortable searchable field="point_name" label="Point Name" >{{ props.row.point_name }}</b-table-column>
                        <b-table-column  sortable searchable field="priority" label="Priority" >{{ props.row.priority }}</b-table-column>
                        <b-table-column  sortable searchable field="type" label="Type" >{{ props.row.type }}</b-table-column>
                        <b-table-column  sortable searchable field="current_value" label="Value" >{{ props.row.current_value }}</b-table-column>
                        <b-table-column  sortable searchable field="point_description" label="Description" >{{ props.row.point_description }}</b-table-column>
                    </template>
            </b-table>
        </div>
        </div>
    </div>
 </b-modal>

   <b-modal v-model="pointsOutOfServiceDetailModalActive" :active.sync="pointsOutOfServiceDetailModalActive" can-cancel>
        <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Hardwire Points in Out of Service</p>
            <button type="button" class="delete" @click="pointsOutOfServiceDetailModalActive=false"/>
        </header>
    <div class="modal-card-body">
        <div class="modal-card-content" >
        <p>The following lists all Apogee field panel hardwired physical points which were reported to the system as "Out of Service".
            Points are taken out of service typically by the end user at the operator workstation to limit alarm activity.
            </p>
          <p>Note: Only points and not subpoints are counted in summary total.</p>       
            <b-table default-sort="point_name" style="max-height:None" :data="report_data.automation_health_report.point_summary_details.out_of_service_points_array" narrowed paginated>
                    <template slot-scope="props">
                         <b-table-column sortable searchable field="panel" label="Panel Name">{{props.row.panel}}</b-table-column>
                        <b-table-column sortable searchable field="point_name" label="Point Name" >{{ props.row.point_name }}</b-table-column>
                        <b-table-column sortable searchable field="priority" label="Priority" >{{ props.row.priority }}</b-table-column>
                        <b-table-column sortable searchable field="type" label="Type" >{{ props.row.type }}</b-table-column>
                        <b-table-column sortable searchable field="current_value" label="Value" >{{ props.row.current_value }}</b-table-column>
                        <b-table-column sortable searchable field="point_description" label="Description" >{{ props.row.point_description }}</b-table-column>
                    </template>
            </b-table>
        </div>
        </div>
    </div>
 </b-modal>

   <b-modal v-model="pointsFailedDetailModalActive" :active.sync="pointsFailedDetailModalActive" can-cancel>
        <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Hardwire Points Failed</p>
            <button type="button" class="delete" @click="pointsFailedDetailModalActive=false"/>
        </header>
    <div class="modal-card-body">
        <div class="modal-card-content" >
            <p>The following lists all Apogee field panel hardwired physical points which were reported to the system as "Failed". 
                Points in the failed condition typically refer to damaged or incorrectly terminated sensors or other physical devices. 
                Points can be associated with main control panels or sub-panels.</p>
            <p>Note: Only points and not subpoints are counted in summary total.</p>         
            <b-table default-sort="point_name" style="max-height:None" :data="report_data.automation_health_report.point_summary_details.failed_points_array" narrowed paginated>
                    <template slot-scope="props">
                         <b-table-column sortable searchable field="panel" label="Panel Name">{{props.row.panel}}</b-table-column>
                        <b-table-column sortable searchable field="point_name" label="Point Name" >{{ props.row.point_name }}</b-table-column>
                        <b-table-column sortable searchable field="priority" label="Priority" >{{ props.row.priority }}</b-table-column>
                        <b-table-column sortable searchable field="type" label="Type" >{{ props.row.type }}</b-table-column>
                        <b-table-column sortable searchable field="current_value" label="Value" >{{ props.row.current_value }}</b-table-column>
                        <b-table-column sortable searchable field="point_description" label="Description" >{{ props.row.point_description }}</b-table-column>
                    </template>
            </b-table>
        </div>
        </div>
    </div>
 </b-modal>


   <b-modal v-model="alarmTransitionsDetailModalActive" :active.sync="alarmTransitionsDetailModalActive" can-cancel>
        <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Alarms</p>
            <button type="button" class="delete" @click="alarmTransitionsDetailModalActive=false"/>
        </header>
    <div class="modal-card-body">
        <div class="modal-card-content" >
            <p>The following table summarizes all the system alarms by point name and frequency over the data record period.</p>  
            <b-table default-sort="total_alarm_transitions" style="max-height:None" :data="alarm_transitions_detailed_table" narrowed paginated>
                    <template slot-scope="props">
                          <b-table-column sortable searchable field="panel_name" label="Panel Name" >{{ props.row.panel}}</b-table-column>        
                        <b-table-column sortable searchable field="point_name" label="Point Name" >{{ props.row.point_name }}</b-table-column>
                    <b-table-column sortable searchable field="total_alarm_transitions" label="Total Alarm Transitions" >{{ props.row.alarm_transitions }}</b-table-column>              
                    
                    </template>
            </b-table>
        </div>
        </div>
    </div>
 </b-modal>

 
   <b-modal v-model="alarmUnresolvedEnhancedAlarmModesDetailModalActive" :active.sync="alarmUnresolvedEnhancedAlarmModesDetailModalActive" can-cancel>
        <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Unresolved Enhanced Alarms – Broken Mode Point</p>
            <button type="button" class="delete" @click="alarmUnresolvedEnhancedAlarmModesDetailModalActive=false"/>
        </header>
    <div class="modal-card-body">
        <div class="modal-card-content" >       
            <b-table default-sort="point_name" style="max-height:None" :data="report_data.automation_health_report.alarm_summary_details.unresolved_enhanced_alarm_modes_array" narrowed paginated>
                    <template slot-scope="props">
                        <b-table-column sortable searchable field="point_name" label="Point Name" >{{ props.row.point_name }}</b-table-column>
                           <b-table-column sortable searchable field="panel_name" label="Panel Name" >{{ props.row.panel_name }}</b-table-column>
                    </template>
            </b-table>
        </div>
        </div>
    </div>
 </b-modal>


 
   <b-modal v-model="alarmUnresolvedEnhancedAlarmSetpointsDetailModalActive" :active.sync="alarmUnresolvedEnhancedAlarmSetpointsDetailModalActive" can-cancel>
        <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Unresolved Enhanced Alarms – Broken Set Point</p>
            <button type="button" class="delete" @click="alarmUnresolvedEnhancedAlarmSetpointsDetailModalActive=false"/>
        </header>
    <div class="modal-card-body">
        <div class="modal-card-content" >
           
            <b-table default-sort="point_name" style="max-height:None" :data="report_data.automation_health_report.alarm_summary_details.unresolved_enhanced_alarm_setpoints_array" narrowed paginated>
                    <template slot-scope="props">
                        <b-table-column sortable searchable field="point_name" label="Point Name" >{{ props.row.point_name }}</b-table-column>
                         <b-table-column sortable searchable field="panel_name" label="Panel Name">{{props.row.panel_name}}</b-table-column> 
                    </template>
            </b-table>
        </div>
        </div>
    </div>
 </b-modal>


        <!-- end of app -->
    </div>
</template>

<script>
import ReactiveChart from '@/components/ReactiveChartwithNonReloadingBubbleChart';
import moment from 'moment';
import Calendar from 'v-calendar/lib/components/calendar.umd'
//VUE ROOT remove password when ready
export default {
	name: 'navigatorChartsDataDashboard',
    components: {ReactiveChart, Calendar},
        // Empty data array to initialise axios data into
        data: function() { return { 
            proxyurl: this.$store.getters.proxyurl,
            apiurl: this.$store.getters.apiurl,
        	loading: true,
            report_loaded:false,
            isCreatePublicLinkModalActive:false,
            password_required:false,
            password:'',
            isFullPage:true,
            title:'',
            passwordModalActive:false,
            message:'',
            canCancelModal:[],
            columns_to_display:1,
            rows_to_display:2,
            displayCharts:true,
            renderComponent:true,
            task_data:{data:[], attachments:[], comments:[]},
            report_info:{report_title:'',created_date:''},
            report_data:{'account_manager_report_tasks':[],
                            'energy_consumption_tasks':[],
                            'navigator_tasks':[],
                            'service_reports_tasks':[],
                            'automation_health_report': {primary_controller_summary:{},
                                                        primary_controller_totals:{},
                                                        point_summary_totals:{},
                                                        point_summary_details:{},
                                                        alarm_summary_totals:{},
                                                        alarm_summary_details:{alarm_transitions_last_30_days_points_array:[]}
                            }
                                                        

                            },
            report_options:{
                include_wrike_report:true,
                include_wrike_service_reports:true,
                include_wrike_navigator_items:true,
                include_wrike_energy_consumption_items:true,
                incldue_wrike_account_manager_items:true,
                account_manager_reports_folder_options:{include_statuses:[], created_date_start:'All',completed_date_start:'Last 60 Days'},
                energy_consumption_items_folder_options:{include_statuses:[], created_date_start:'All',completed_date_start:'Last 60 Days'},
                navigator_items_folder_options:{include_statuses:[], created_date_start:'All',completed_date_start:'Last 60 Days'},
                service_reports_folder_options:{include_statuses:[], created_date_start:'All',completed_date_start:'Last 60 Days'},
                include_apogee_health_check_report:true,
                include_apogee_health_check_alarm_summary:true,
                include_apogee_health_check_panel_summary:true,
                include_apogee_health_check_points_summary:true,
                include_apogee_health_check_fln_summary:false, 
                apogee_health_check_alarm_summary_period:"Last 30 Days"//not yet programmed, can't find all devices in csv
                    },
                            
            task_data_loaded:false,
            taskModalActive:false,
            panelIssuesPointsTotalsModalActive:false,
            pointsOPERDetailModalActive:false,
            pointsOutOfServiceDetailModalActive:false,
            pointsFailedDetailModalActive:false,
            alarmTransitionsDetailModalActive:false,
            alarmUnresolvedEnhancedAlarmModesDetailModalActive:false,
            alarmUnresolvedEnhancedAlarmSetpointsDetailModalActive:false,   
            printing_chart_height_full: 350,
            printing_chart_height_small:350,
            printing_chart_width_full:750,
            printing_chart_width_small:750,
            printing_mode:false,
            latest_completed_date:moment('1970-01-01').toDate()

            

        }
    },


    computed:{
        filtered_navigator_tasks(){
            //return filtered navigator tasks with statuses (workflows) to include
            let tasks = JSON.parse(JSON.stringify(this.report_data.navigator_tasks)); //deep copy
            let list_of_statuses_to_include = []
            this.report_options.navigator_items_folder_options.include_statuses.forEach((status)=>{list_of_statuses_to_include.push(status.id)})
            let filtered_tasks = []
                tasks.forEach((task)=>{
                    if (list_of_statuses_to_include.includes(task.customStatusId)){
                        filtered_tasks.push(task)
                    }
                })
            return filtered_tasks
        },
        filtered_energy_consumption_tasks(){
            //return filtered energy consumption tasks with statuses (workflows) to include
            let tasks = JSON.parse(JSON.stringify(this.report_data.energy_consumption_tasks)); //deep copy
            let list_of_statuses_to_include = []
            this.report_options.energy_consumption_items_folder_options.include_statuses.forEach((status)=>{list_of_statuses_to_include.push(status.id)})
            let filtered_tasks = []
                tasks.forEach((task)=>{
                    if (list_of_statuses_to_include.includes(task.customStatusId)){
                        filtered_tasks.push(task)
                    }
                })
            return filtered_tasks
        },
        filtered_service_report_tasks(){
               //return filtered service report tasks with statuses (workflows) to include         
            let tasks = JSON.parse(JSON.stringify(this.report_data.service_reports_tasks)); //deep copy
            let list_of_statuses_to_include = []
            this.report_options.service_reports_folder_options.include_statuses.forEach((status)=>{list_of_statuses_to_include.push(status.id)})            
            let filtered_tasks = []
                tasks.forEach((task)=>{
                    if (list_of_statuses_to_include.includes(task.customStatusId)){
                        filtered_tasks.push(task)
                    }
                })
            return filtered_tasks
        },
        filtered_account_review_tasks(){
            //return filtered account review tasks with statuses (workflows) to include         
            let tasks = JSON.parse(JSON.stringify(this.report_data.account_manager_report_tasks)); //deep copy
            let list_of_statuses_to_include = []
            this.report_options.account_manager_reports_folder_options.include_statuses.forEach((status)=>{list_of_statuses_to_include.push(status.id)})            
            let filtered_tasks = []
                tasks.forEach((task)=>{
                    if (list_of_statuses_to_include.includes(task.customStatusId)){
                        filtered_tasks.push(task)
                    }
                })

            return filtered_tasks
        },
        //all filtered tasks into one list (removing any duplicates)
        filtered_all_tasks(){
            let tasks = []
                this.filtered_navigator_tasks.forEach((task)=>{if(!tasks.includes(task)){tasks.push(task)}})
                this.filtered_account_review_tasks.forEach((task)=>{if(!tasks.includes(task)){tasks.push(task)}})
                this.filtered_energy_consumption_tasks.forEach((task)=>{if(!tasks.includes(task)){tasks.push(task)}})
                this.filtered_service_report_tasks.forEach((task)=>{if(!tasks.includes(task)){tasks.push(task)}})
            return tasks
        },               
        report_total_tasks_metric(){
            let tasks_count = 0
            let tasks = JSON.parse(JSON.stringify(this.filtered_all_tasks));
            tasks.forEach((task)=>{
                tasks_count += 1
            })
            return tasks_count
        },
        report_active_tasks_metric(){
            //currently counts Active if workflow is in "Active" group in Wrike
            let tasks_count = 0
            let tasks = JSON.parse(JSON.stringify(this.filtered_all_tasks));
            tasks.forEach((task)=>{
                if (task.status== "Active"){
                tasks_count += 1
                }
            })
            return tasks_count
        },
        report_new_tasks_metric(){
            //currently counts new if workflow if created date is more recent than 1 month from report creation date 
            let tasks_count = 0
            let tasks = JSON.parse(JSON.stringify(this.filtered_all_tasks));
            tasks.forEach((task)=>{
                if (moment(this.report_info.created_date,'DD/MM/YYYY').add(-1, 'M') < moment(task.createdDate)){
                tasks_count += 1
                }
            })
            return tasks_count
        },
        report_overdue_tasks_metric(){
            //currently counts overdue if task status is not "Completed", due date exists and due date is greater than report_creation date
            let tasks_count = 0
            let tasks = JSON.parse(JSON.stringify(this.filtered_all_tasks));
            tasks.forEach((task)=>{
                if (task.status != "Completed"){
                    if ("due" in task.dates){
                        if ( moment(task.dates.due)  < moment(this.report_info.created_date,'DD/MM/YY')){
                        tasks_count += 1
                        }
                    }
                }
            })
            return tasks_count
        },

        report_task_completion_progress_metric(){
            //gets percent of completed tasks/total tasks
             //currently counts completed tasks as task status = "Completed" (workflow group)
            let total_tasks_count = 0
            let completed_tasks_count = 0

            let tasks = JSON.parse(JSON.stringify(this.filtered_all_tasks));
            tasks.forEach((task)=>{
                if (task.status== "Completed"){
                completed_tasks_count += 1
                }
                total_tasks_count += 1
            })

            let task_completion_percent = Math.round(100*completed_tasks_count/total_tasks_count)
            return task_completion_percent         
        },
        report_service_reports_table(){
            let data = JSON.parse(JSON.stringify(this.filtered_service_report_tasks));
             data.forEach((task)=>{
                //Creator String
                let author_string = ""
                task.authorIds.forEach((id)=>{
                    author_string += id + ", "
                })
                task.authorIds = author_string.slice(0, -2); 

                //Assignees(Responsible) String
                let assignees_string = ""
                task.responsibleIds.forEach((id)=>{
                    assignees_string += id + ", "
                })
                task.responsibleIds = assignees_string.slice(0, -2);

                //created date string
                task.createdDate = moment(task.createdDate).format('DD/MM/YY')
                //due date string
                if ("due" in task.dates){
                 task.dueDate =  moment(task.dates.due).format('DD/MM/YY')
                }else{
                task.dueDate = 'N/A'
                }
                //completed date string
                if ("completedDate" in task){
                 task.completedDate =  moment(task.completedDate).format('DD/MM/YY')
                }else{
                task.completedDate = 'N/A'
                }
              
            })

            return data
        },
        report_navigator_items_table(){
            let data = JSON.parse(JSON.stringify(this.filtered_navigator_tasks)); 
            data.forEach((task)=>{
                //Creator String
                let author_string = ""
                task.authorIds.forEach((id)=>{
                    author_string += id + ", "
                })
                task.authorIds = author_string.slice(0, -2); 

                //Assignees(Responsible) String
                let assignees_string = ""
                task.responsibleIds.forEach((id)=>{
                    assignees_string += id + ", "
                })
                task.responsibleIds = assignees_string.slice(0, -2);

                //created date string
                task.createdDate = moment(task.createdDate).format('DD/MM/YY')
                //due date string
                if ("due" in task.dates){
                 task.dueDate =  moment(task.dates.due).format('DD/MM/YY')
                }else{
                task.dueDate = 'N/A'
                }
                //completed date string
                if ("completedDate" in task){
                 task.completedDate =  moment(task.completedDate).format('DD/MM/YY')
                }else{
                task.completedDate = 'N/A'
                }
              
            })

            return data
        },
        report_energy_consumption_items_table(){
            let data = JSON.parse(JSON.stringify(this.filtered_energy_consumption_tasks));
             data.forEach((task)=>{
                //Creator String
                let author_string = ""
                task.authorIds.forEach((id)=>{
                    author_string += id + ", "
                })
                task.authorIds = author_string.slice(0, -2); 

                //Assignees(Responsible) String
                let assignees_string = ""
                task.responsibleIds.forEach((id)=>{
                    assignees_string += id + ", "
                })
                task.responsibleIds = assignees_string.slice(0, -2);

                //created date string
                task.createdDate = moment(task.createdDate).format('DD/MM/YY')
                //due date string
                if ("due" in task.dates){
                 task.dueDate =  moment(task.dates.due).format('DD/MM/YY')
                }else{
                task.dueDate = 'N/A'
                }
                //completed date string
                if ("completedDate" in task){
                 task.completedDate =  moment(task.completedDate).format('DD/MM/YY')
                }else{
                task.completedDate = 'N/A'
                }
              
            })

            return data
        },
        report_account_review_items_table(){
            let data = JSON.parse(JSON.stringify(this.filtered_account_review_tasks));
             data.forEach((task)=>{
                //Creator String
                let author_string = ""
                task.authorIds.forEach((id)=>{
                    author_string += id + ", "
                })
                task.authorIds = author_string.slice(0, -2); 

                //Assignees(Responsible) String
                let assignees_string = ""
                task.responsibleIds.forEach((id)=>{
                    assignees_string += id + ", "
                })
                task.responsibleIds = assignees_string.slice(0, -2);

                //created date string
                task.createdDate = moment(task.createdDate).format('DD/MM/YY')
                //due date string
                if ("due" in task.dates){
                 task.dueDate =  moment(task.dates.due).format('DD/MM/YY')
                }else{
                task.dueDate = 'N/A'
                }
                //completed date string
                if ("completedDate" in task){
                 task.completedDate =  moment(task.completedDate).format('DD/MM/YY')
                }else{
                task.completedDate = 'N/A'
                }
              
            })

            return data
        },
        report_site_status_overview_pie_chart(){
            //get total of each status for each task
            let totals_dict = {}
            let tasks_data =  JSON.parse(JSON.stringify(this.filtered_all_tasks));
            tasks_data.forEach((task)=>{
                //if status is in dict then add 1 to count
                if (task.customStatus.id in totals_dict){
                    totals_dict[task.customStatus.id].count += 1
                }else{
                //if status is not yet in dict (first count) then add to dict
                 totals_dict[task.customStatus.id] = {count:1, name:task.customStatus.name, colour:task.customStatus.hex}
                }
            })

            //iterate through totals dictionary and set up chart data/traces
            let values = []
            let labels = []
            let colours = []
            for (var key in totals_dict){
            values.push(totals_dict[key].count)
            labels.push(totals_dict[key].name)  
            colours.push(totals_dict[key].colour)                    
            }

            //chart data
            var data = [{
            type: "pie",
            values: values,
            labels: labels,
            marker: {
                colors: colours
            },
            textinfo: "label+value",
            textposition: "outside",
            }]

            //chart layout
            var layout = {
            margin: {"t": 0, "b": 50, "l":100, "r": 100},
            showlegend: true,
            legend: {"orientation": "h"}
            }

             if (this.printing_mode == true){
                layout.width= this.printing_chart_width_full
                layout.height= this.printing_chart_height_full
            }

            return {uuid: 'site_status_overview_pie_chart',
              traces: data,
              layout: layout, 
              editable: false,
              displayModeBar: false, 
              chartVersion: 2}  
   
        },
        report_tasks_by_assignee_histogram_chart(){
            let tasks_data =  JSON.parse(JSON.stringify(this.filtered_all_tasks));

            //get total of each status for each task
            let totals_dict = {}
            let unique_assignees = []
            let unique_statuses = []

            //iterate through tasks and get unique lis of assigness and statuses
            tasks_data.forEach((task)=>{
                let assignee_name = "N/A"
                //create list of assignees
                if (task.responsibleIds == "" || task.responsibleIds == []){
                     if (!unique_assignees.includes(assignee_name)){
                           unique_assignees.push(assignee_name)
                       }          
                }else{
                   task.responsibleIds.forEach((assignee)=>{
                       let assignee_name = assignee
                       if (!unique_assignees.includes(assignee_name)){
                           unique_assignees.push(assignee_name)
                       }
                   })          
                   
                }
      
                //create list of include_statuses
             if (!unique_statuses.includes(task.customStatus.id)){
                           unique_statuses.push(task.customStatus)
                }                
            })

            //create totals dict structure
            unique_statuses.forEach((status)=>{
                totals_dict[status['id']]={name: status['name'], colour: status['hex'], assignees:{}}
                unique_assignees.forEach((assignee)=>{
                     totals_dict[status['id']]['assignees'][assignee] = {count:0, name:status.name, colour:status.hex}
                })
            })

            //iterate through tasks and get counts for each assignee and status
            tasks_data.forEach((task)=>{
                if (task.responsibleIds == "" || task.responsibleIds == []){
                let assignee = "N/A"
                      totals_dict[task.customStatus.id]['assignees'][assignee].count +=1
                }else{
                   task.responsibleIds.forEach((assignee)=>{
                     totals_dict[task.customStatus.id]['assignees'][assignee].count +=1     
                   })
                }       
            })

            //create chart traces
            let traces_array = []
            for (var status_key in totals_dict){
                let x_array = []
                let y_array = []
                let status_name = totals_dict[status_key].name
                let status_colour = totals_dict[status_key].colour

                for (var assignee_key in totals_dict[status_key]['assignees']){
                    x_array.push(assignee_key)
                    y_array.push(totals_dict[status_key]['assignees'][assignee_key].count)                  
                }     
                traces_array.push({
                    x: x_array,
                    y: y_array,
                    name: status_name,
                    type: 'bar',
                     marker: {
                        color: status_colour
                    }
                })         
            }
            
            var data = traces_array;

            
            var layout = {barmode: 'group', 
                    margin: {"t": 0, "b": 100, "l":100, "r": 100},
                    showlegend:true,
                    legend: {"orientation": "h"}};

             if (this.printing_mode == true){
                layout.width= this.printing_chart_width_full
                layout.height= this.printing_chart_height_full
            }


            return {uuid: 'report_tasks_by_assignee_histogram_chart',
              traces: data,
              layout: layout, 
              editable: false,
              displayModeBar: false, 
              chartVersion: 2}  
         },


        report_onsite_service_completed_calendar_chart(){
                    //get total of each status for each task
     
                    let totals_dict = {}
                    let tasks_data =  JSON.parse(JSON.stringify(this.filtered_all_tasks));
                     tasks_data.forEach((task)=>{
                         if ("completedDate" in task){
                            let completedDateString = moment(task.completedDate).format('DD/MM/YYYY')
                             //if status is in dict then add 1 to count
                            if (task.customStatus.id in totals_dict){
                                totals_dict[completedDateString].count += 1
                            }else{
                            //if status is not yet in dict (first count) then add to dict
                            totals_dict[completedDateString] = {count:1, name:task.customStatus.name, colour:task.customStatus.hex}
                          }
                         }
                       
                    })

                    let attributes_array = []
                     for (var key in totals_dict){

                        //if latest completed date is more recent, then update latest complete date variable
                        //which will move calendar via a watcher watching the latest completed date variable
                         if (this.latest_completed_date < moment(key, 'DD/MM/YYYY').toDate())
                         {
                             this.latest_completed_date = moment(key, 'DD/MM/YYYY').toDate()
                         }


                         attributes_array.push({
                                key: key,
                                highlight: 'teal',
                                dates: moment(key, 'DD/MM/YYYY').toDate(),
                                popover: {
                                    label: 'Completed Tasks: ' + totals_dict[key].count
                                    }
                                 })
                     }
            
            //*************Need to find way to move calendar to last date... this.$refs.calendar not working */

            return attributes_array
        },
        report_navigator_tasks_overview_pie_chart(){
            //get total of each status for each task
            let totals_dict = {}
            let tasks_data =  this.filtered_navigator_tasks
            tasks_data.forEach((task)=>{
                //if status is in dict then add 1 to count
                if (task.customStatus.id in totals_dict){
                    totals_dict[task.customStatus.id].count += 1
                }else{
                //if status is not yet in dict (first count) then add to dict
                 totals_dict[task.customStatus.id] = {count:1, name:task.customStatus.name, colour:task.customStatus.hex}
                }
            })

            //iterate through totals dictionary and set up chart data/traces
            let values = []
            let labels = []
            let colours = []
            for (var key in totals_dict){
            values.push(totals_dict[key].count)
            labels.push(totals_dict[key].name)  
            colours.push(totals_dict[key].colour)                    
            }

            //chart data
            var data = [{
            type: "pie",
            hole: .4, //for donut
            values: values,
            labels: labels,
            marker: {
                colors: colours
            },
            textinfo: "label+value",
            textposition: "outside",
            }]

            //chart layout
            var layout = {
            margin: {"t": 0, "b": 100, "l":100, "r": 100},
            showlegend: true,
            legend: {"orientation": "h"}
            }

             if (this.printing_mode == true){
                layout.width= this.printing_chart_width_full
                layout.height= this.printing_chart_height_full
            }
            return {uuid: 'site_status_overview_pie_chart',
              traces: data,
              layout: layout, 
              editable: false,
              displayModeBar: false, 
              chartVersion: 2}  
   
        },
        report_energy_consumption_tasks_by_assignee_histogram_chart(){
            let tasks_data =  this.filtered_energy_consumption_tasks

            //get total of each status for each task
            let totals_dict = {}
            let unique_assignees = []
            let unique_statuses = []

            //iterate through tasks and get unique lis of assigness and statuses
            tasks_data.forEach((task)=>{
                let assignee_name = "N/A"
                //create list of assignees
                if (task.responsibleIds == "" || task.responsibleIds == []){
                     if (!unique_assignees.includes(assignee_name)){
                           unique_assignees.push(assignee_name)
                       }          
                }else{
                   task.responsibleIds.forEach((assignee)=>{
                       let assignee_name = assignee
                       if (!unique_assignees.includes(assignee_name)){
                           unique_assignees.push(assignee_name)
                       }
                   })          
                   
                }
      
                //create list of include_statuses
             if (!unique_statuses.includes(task.customStatus.id)){
                           unique_statuses.push(task.customStatus)
                }                
            })

            //create totals dict structure
            unique_statuses.forEach((status)=>{
                totals_dict[status['id']]={name: status['name'], colour: status['hex'], assignees:{}}
                unique_assignees.forEach((assignee)=>{
                     totals_dict[status['id']]['assignees'][assignee] = {count:0, name:status.name, colour:status.hex}
                })
            })

  
            //iterate through tasks and get counts for each assignee and status
            tasks_data.forEach((task)=>{
                if (task.responsibleIds == "" || task.responsibleIds == []){
                let assignee = "N/A"
                      totals_dict[task.customStatus.id]['assignees'][assignee].count +=1
                }else{
                   task.responsibleIds.forEach((assignee)=>{
                     totals_dict[task.customStatus.id]['assignees'][assignee].count +=1     
                   })
                }       
    
            })

            //create chart traces
            let traces_array = []
            for (var status_key in totals_dict){
                let x_array = []
                let y_array = []
                let status_name = totals_dict[status_key].name
                let status_colour = totals_dict[status_key].colour

                for (var assignee_key in totals_dict[status_key]['assignees']){
                    x_array.push(assignee_key)
                    y_array.push(totals_dict[status_key]['assignees'][assignee_key].count)                  
                }     
                traces_array.push({
                    x: x_array,
                    y: y_array,
                    name: status_name,
                    type: 'bar',
                     marker: {
                        color: status_colour
                    }
                })         
            }
            
            var data = traces_array;
            var layout = {barmode: 'group', 
                    margin: {"t": 0, "b": 100, "l":100, "r": 100},
                    showlegend:true,
                    legend: {"orientation": "h"}};

             if (this.printing_mode == true){
                layout.width= this.printing_chart_width_full
                layout.height= this.printing_chart_height_full
            }
            return {uuid: 'report_energy_consumption_tasks_by_assignee_histogram_chart',
              traces: data,
              layout: layout, 
              editable: false,
              displayModeBar: false, 
              chartVersion: 2}  

        },
        report_account_tasks_overview_pie_chart(){
            //get total of each status for each task
            let totals_dict = {}
            let tasks_data =  this.filtered_account_review_tasks
            tasks_data.forEach((task)=>{
                //if status is in dict then add 1 to count
                if (task.customStatus.id in totals_dict){
                    totals_dict[task.customStatus.id].count += 1
                }else{
                //if status is not yet in dict (first count) then add to dict
                 totals_dict[task.customStatus.id] = {count:1, name:task.customStatus.name, colour:task.customStatus.hex}
                }
            })

            //iterate through totals dictionary and set up chart data/traces
            let values = []
            let labels = []
            let colours = []
            for (var key in totals_dict){
            values.push(totals_dict[key].count)
            labels.push(totals_dict[key].name)  
            colours.push(totals_dict[key].colour)                    
            }

            //chart data
            var data = [{
            type: "pie",
            hole: .4, //for donut
            values: values,
            labels: labels,
            marker: {
                colors: colours
            },
            textinfo: "label+value",
            textposition: "outside",
  
            }]

            //chart layout
            var layout = {
            margin: {"t": 0, "b": 50, "l":50, "r": 50},
            showlegend: true,
            legend: {"orientation": "h"}
            }

             if (this.printing_mode == true){
                layout.width= this.printing_chart_width_small   
                 layout.height= this.printing_chart_height_small
            }

            return {uuid: 'site_status_overview_pie_chart',
              traces: data,
              layout: layout, 
              editable: false,
              displayModeBar: false, 
              chartVersion: 2}  
   
        },
        report_account_tasks_by_assignee_histogram_chart(){
            let tasks_data =  this.filtered_account_review_tasks

            //get total of each status for each task
            let totals_dict = {}
            let unique_assignees = []
            let unique_statuses = []

            //iterate through tasks and get unique lis of assigness and statuses
            tasks_data.forEach((task)=>{
                let assignee_name = "N/A"
                //create list of assignees
                if (task.responsibleIds == "" || task.responsibleIds == []){
                     if (!unique_assignees.includes(assignee_name)){
                           unique_assignees.push(assignee_name)
                       }          
                }else{
                   task.responsibleIds.forEach((assignee)=>{
                       let assignee_name = assignee
                       if (!unique_assignees.includes(assignee_name)){
                           unique_assignees.push(assignee_name)
                       }
                   })          
                   
                }
      
                //create list of include_statuses
             if (!unique_statuses.includes(task.customStatus.id)){
                           unique_statuses.push(task.customStatus)
                }                
            })

            //create totals dict structure
            unique_statuses.forEach((status)=>{
                totals_dict[status['id']]={name: status['name'], colour: status['hex'], assignees:{}}
                unique_assignees.forEach((assignee)=>{
                     totals_dict[status['id']]['assignees'][assignee] = {count:0, name:status.name, colour:status.hex}
                })
            })

            //iterate through tasks and get counts for each assignee and status
            tasks_data.forEach((task)=>{
                if (task.responsibleIds == "" || task.responsibleIds == []){
                let assignee = "N/A"
                      totals_dict[task.customStatus.id]['assignees'][assignee].count +=1
                }else{
                   task.responsibleIds.forEach((assignee)=>{
                     totals_dict[task.customStatus.id]['assignees'][assignee].count +=1     
                   })
                }       
            })

            //create chart traces
            let traces_array = []
            for (var status_key in totals_dict){
                let x_array = []
                let y_array = []
                let status_name = totals_dict[status_key].name
                let status_colour = totals_dict[status_key].colour

                for (var assignee_key in totals_dict[status_key]['assignees']){
                    x_array.push(assignee_key)
                    y_array.push(totals_dict[status_key]['assignees'][assignee_key].count)                  
                }     
                traces_array.push({
                    x: x_array,
                    y: y_array,
                    name: status_name,
                    type: 'bar',
                     marker: {
                        color: status_colour
                    }
                })         
            }
            
            var data = traces_array;
            var layout = {barmode: 'group', 
                    margin: {"t": 0, "b": 50, "l":50, "r": 50},
                    showlegend:true,
                    legend: {"orientation": "h"}};

                if (this.printing_mode == true){
                        layout.width= this.printing_chart_width_small   
                    layout.height= this.printing_chart_height_small
                }

            return {uuid: 'report_account_tasks_by_assignee_histogram_chart',
              traces: data,
              layout: layout, 
              editable: false,
              displayModeBar: false, 
              chartVersion: 2}  

        },       



        task_data_formatted(){
            //create copy
            let task_data = this.task_data
            //convert iso times to moments 
            task_data.data[0].createdDate = moment(task_data.data[0].createdDate).format('lll')
            task_data.comments.forEach((comment)=>
            {
                comment.createdDate = moment(comment.createdDate).format('lll')
            })
            task_data.attachments.forEach((attachment)=>
            {
                attachment.createdDate = moment(attachment.createdDate).format('lll')
            })                    

            //get hex for custom status
            task_data.data[0].customStatus.hex = this.report_data.colours[task_data.data[0].customStatus.color]

            //assignees/responsible
            let assignees_string = ""
            task_data.data[0].responsibleIds.forEach((assignee)=>{
                assignees_string = assignees_string + assignee + ", "
            })
            task_data.data[0].responsibleIds = assignees_string.slice(0, -2)

            return task_data
        },

            apogee_health_check_panel_summary_table(){
            let data = JSON.parse(JSON.stringify(this.report_data.automation_health_report.primary_controller_summary));
            return data
        },

         apogee_health_check_panel_summary_graph(){
  
            //iterate through totals dictionary and set up chart data/traces
            let values = [this.report_data.automation_health_report.primary_controller_totals.Supported,
             this.report_data.automation_health_report.primary_controller_totals.Retired ]
            let labels = ['Supported', "Retired"]
            let colours = ["#009999", "#EF0137"]

            //chart data
            var data = [{
            type: "pie",
            values: values,
            labels: labels,
            marker: {
                colors: colours
            },
            textinfo: "label+value",
            textposition: "outside",
            }]

            //chart layout
            var layout = {
            margin: {"t": 0, "b": 100, "l":100, "r": 100},
            showlegend: true,
            legend: {"orientation": "h"}
            }

             if (this.printing_mode == true){
                layout.width= this.printing_chart_width_full
                layout.height= this.printing_chart_height_full
            }
            return {uuid: 'apogee_panel_summary_graph',
              traces: data,
              layout: layout, 
              editable: false,
              displayModeBar: false, 
              chartVersion: 2}  
   
        },
      apogee_health_check_points_summary_table(){
            let data = JSON.parse(JSON.stringify(this.report_data.automation_health_report.point_summary_totals));
           
            let table_data = []
            table_data.push({'description':'# of Total Panels', 'total':data.n_total_panels, 'extra_details':true})
            table_data.push({'description':'# of Points In System', 'total':data.n_total_points_in_system, 'extra_details':false})
            table_data.push({'description':'# of Physical Points', 'total':data.n_physical_points_in_system, 'extra_details':false})           
            table_data.push({'description':'# of Virtual Points', 'total':data.n_virtual_points_in_system, 'extra_details':false})
            table_data.push({'description':'# of Unbundled Points', 'total':data.n_total_unbundled_points_in_system, 'extra_details':false})
            table_data.push({'description':'# of Trended Points', 'total':data.n_total_trend_points_in_system, 'extra_details':false})
            table_data.push({'description':'# of Points Failed', 'total': parseInt(data.n_points_failed) , 'extra_details':true})
            table_data.push({'description':'# of Points Out of Service', 'total': parseInt(data.n_points_out_of_service), 'extra_details':true})
            table_data.push({'description':'# of Points in OPER Priority', 'total': parseInt(data.n_points_in_OPER), 'extra_details':true})

            return table_data
        },

    apogee_health_check_points_summary_graph(){
        let table_data = JSON.parse(JSON.stringify(this.report_data.automation_health_report.point_summary_totals));        
            //iterate through totals dictionary and set up chart data/traces
            let values = [
                (parseInt(table_data.n_total_points_in_system) - parseInt(table_data.n_points_failed) -  parseInt(table_data.n_points_out_of_service)- parseInt(table_data.n_points_in_OPER)),
                parseInt(table_data.n_points_failed),
                parseInt(table_data.n_points_out_of_service),
                parseInt(table_data.n_points_in_OPER)
            ]
            let labels = ["Nominal Points", "Points Failed", "Points Out of Services", "Points in OPER Priority"]
            let colours = ["#009999", "#EF0137",  "#FF9000", "#FFD732"]
            //chart data
            var data = [{
            type: "pie",
            values: values,
            labels: labels,
            marker: {
                colors: colours
            },
            textinfo: "label+value",
            textposition: "outside",
            }]

            //chart layout
            var layout = {
            margin: {"t": 100, "b": 0, "l":100, "r": 100},
            showlegend: true,
            legend: {"orientation": "h"}
            }

             if (this.printing_mode == true){
                layout.width= this.printing_chart_width_full
                layout.height= this.printing_chart_height_full
            }

            return {uuid: 'apogee_points_summary_graph',
              traces: data,
              layout: layout, 
              editable: false,
              displayModeBar: false, 
              chartVersion: 2}  
   
        },
              apogee_health_check_alarm_summary_table(){
            let data = JSON.parse(JSON.stringify(this.report_data.automation_health_report.alarm_summary_totals));
            let table_data = []
            if(this.report_options.apogee_health_check_alarm_summary_period == "Last 90 Days"){
            table_data.push({'description':'Total Alarms for period', 'total':data.n_total_alarms_last_90_days, 'extra_details':false})
            table_data.push({'description':'Total Unique Alarms for period', 'total':data.n_total_unique_alarms_last_90_days, 'extra_details':true})
            table_data.push({'description':'Total Fault Alarms for period', 'total':data.n_total_fault_alarms_last_90_days, 'extra_details':false})           
            table_data.push({'description':'Total Alarms Return To Normal for period', 'total':data.n_total_return_to_normal_last_90_days, 'extra_details':false})
            table_data.push({'description':'Total Fault Alarms for period', 'total':data.n_total_fault_alarms_last_90_days, 'extra_details':false})
            table_data.push({'description':'Total Enhanced Alarm Points ', 'total':data.n_total_enhanced_alarm_points_in_system, 'extra_details':false})
            table_data.push({'description':'Unresolved Enhanced Alarm Modes', 'total': data.n_total_unresolved_enhanced_alarm_modes , 'extra_details':true})
            table_data.push({'description':'Unresolved Enhanced Alarm Setpoints', 'total': data.n_total_unresolved_enhanced_alarm_setpoints, 'extra_details':true})
            }
            if(this.report_options.apogee_health_check_alarm_summary_period == "Last 60 Days"){
            table_data.push({'description':'Total Alarms for period', 'total':data.n_total_alarms_last_60_days, 'extra_details':false})
            table_data.push({'description':'Total Unique Alarms for period', 'total':data.n_total_unique_alarms_last_60_days, 'extra_details':true})
            table_data.push({'description':'Total Fault Alarms for period', 'total':data.n_total_fault_alarms_last_60_days, 'extra_details':false})           
            table_data.push({'description':'Total Alarms Return To Normal for period', 'total':data.n_total_return_to_normal_last_60_days, 'extra_details':false})
            table_data.push({'description':'Total Fault Alarms for period', 'total':data.n_total_fault_alarms_last_60_days, 'extra_details':false})
            table_data.push({'description':'Total Enhanced Alarm Points ', 'total':data.n_total_enhanced_alarm_points_in_system, 'extra_details':false})
            table_data.push({'description':'Unresolved Enhanced Alarm Modes', 'total': data.n_total_unresolved_enhanced_alarm_modes , 'extra_details':true})
            table_data.push({'description':'Unresolved Enhanced Alarm Setpoints', 'total': data.n_total_unresolved_enhanced_alarm_setpoints, 'extra_details':true})
            }
            if(this.report_options.apogee_health_check_alarm_summary_period == "Last 30 Days"){
            table_data.push({'description':'Total Alarms for period', 'total':data.n_total_alarms_last_30_days, 'extra_details':false})
            table_data.push({'description':'Total Unique Alarms for period', 'total':data.n_total_unique_alarms_last_30_days, 'extra_details':true})
            table_data.push({'description':'Total Fault Alarms for period', 'total':data.n_total_fault_alarms_last_30_days, 'extra_details':false})           
            table_data.push({'description':'Total Alarms Return To Normal for period', 'total':data.n_total_return_to_normal_last_30_days, 'extra_details':false})
            table_data.push({'description':'Total Fault Alarms for period', 'total':data.n_total_fault_alarms_last_30_days, 'extra_details':false})
            table_data.push({'description':'Total Enhanced Alarm Points ', 'total':data.n_total_enhanced_alarm_points_in_system, 'extra_details':false})
            table_data.push({'description':'Unresolved Enhanced Alarm Modes', 'total': data.n_total_unresolved_enhanced_alarm_modes , 'extra_details':true})
            table_data.push({'description':'Unresolved Enhanced Alarm Setpoints', 'total': data.n_total_unresolved_enhanced_alarm_setpoints, 'extra_details':true})
            }
            return table_data
        },

        alarm_transitions_detailed_table(){
            let table_data = []
            if(this.report_options.apogee_health_check_alarm_summary_period == "Last 90 Days"){
           table_data = this.report_data.automation_health_report.alarm_summary_details.alarm_transitions_last_90_days_points_array
            }
            if(this.report_options.apogee_health_check_alarm_summary_period == "Last 60 Days"){
           table_data = this.report_data.automation_health_report.alarm_summary_details.alarm_transitions_last_60_days_points_array            }
            if(this.report_options.apogee_health_check_alarm_summary_period == "Last 30 Days"){
           table_data = this.report_data.automation_health_report.alarm_summary_details.alarm_transitions_last_30_days_points_array            }
            return table_data       
        },

         apogee_health_check_alarm_summary_graph(){
            let alarms_data = []
            if(this.report_options.apogee_health_check_alarm_summary_period == "Last 90 Days"){
            alarms_data =  JSON.parse(JSON.stringify(this.report_data.automation_health_report.alarm_summary_details.alarm_transitions_last_90_days_points_array)).slice(0, 10); //get first 10 elements
            }
            if(this.report_options.apogee_health_check_alarm_summary_period == "Last 60 Days"){
            alarms_data =  JSON.parse(JSON.stringify(this.report_data.automation_health_report.alarm_summary_details.alarm_transitions_last_60_days_points_array)).slice(0, 10); //get first 10 elements          
            }
            if(this.report_options.apogee_health_check_alarm_summary_period == "Last 30 Days"){
             alarms_data =  JSON.parse(JSON.stringify(this.report_data.automation_health_report.alarm_summary_details.alarm_transitions_last_30_days_points_array)).slice(0, 10); //get first 10 elements         
            }   

            let x_array = []
            let y_array = []
            alarms_data.forEach((alarm)=>{
                x_array.unshift(alarm.alarm_transitions)
                y_array.unshift(alarm.point_name)
    
            })

        var data = [{
            type: 'bar',
            x: x_array,
            y: y_array,
            orientation: 'h',
             marker: {
                color: '#009999',
                width: 0.5
            }
            }];

            //chart layout
            var layout = {
            margin: {"t": 50, "b": 50, "l": 300, "r": 0},
            showlegend: false,
            legend: {"orientation": "h"}
            }

             if (this.printing_mode == true){
                layout.width= this.printing_chart_width_full
                layout.height= this.printing_chart_height_full
            }

            return {uuid: 'apogee_points_alarm_summary_graph',
              traces: data,
              layout: layout, 
              editable: false,
              displayModeBar: false, 
              chartVersion: 2}  
   
        },

    },

        methods: {         	
                async get_task_data(wrike_task_id){
             this.loading=true;
             this.task_data_loaded=false;
             const url = this.apiurl + "get_wrike_task_data"
             
             //return for the async await
            await this.$axios({
                    method: 'POST',
                    url: url,
                    data: {
                        //'password': this.password,
                         'wrike_task_id': wrike_task_id,
                         'unique_uuid': this.$route.params.uuid
                    },
                    headers: {
                        'content-type': 'application/json',
                    }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
                })
                .then((response) => {
                    
                this.task_data = response.data
                this.task_data_loaded=true;
                   this.taskModalActive=true;
                 this.loading=false;
             
                 
               }).catch(error => {
                        console.log(error)
                        this.taskModalActive=false;
                        this.task_data_loaded=false;
                        this.loading=false;

                }); 
        },

        async downloadAttachment(wrike_attachment_id){
                        const url = this.$store.getters.apiurl + "download_wrike_attachment"
                         let data=  {
                        'wrike_attachment_id': wrike_attachment_id,
                           'unique_uuid': this.$route.params.uuid
                         }
                        await this.$axios({ method: 'POST',url: url, data:data, responseType: 'blob',headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded'},
                        }).then(res => {
                            let content_type = res.headers['content-type']
                            let mime_type = content_type.split(";_;")[0]
                            let file_name = content_type.split(";_;")[1]
                            let data = res.data;
                            const blob = new Blob([data], { type: mime_type })
                            let link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = file_name
                            link.click()
                        }).catch(error => { 
                        console.log(error)             
                        });  
                
        },

        async get_report_data_for_link(password){
             this.loading=true;
             const url = this.apiurl + "get_report_data_for_link"
             
             //return for the async await
            await this.$axios({
                    method: 'POST',
                    url: url,
                    data: {
                        'password': this.password,
                        'uuid': this.$route.params.uuid
                    },
                    headers: {
                        'content-type': 'application/json',
                    }
                })
                .then((response) => {
                this.report_data = response.data.report_data
                this.report_info = response.data.report_data.report_info
                this.report_options = response.data.report_data.report_options
                this.report_loaded= response.data.report_loaded
                this.message=response.data.message
                this.title = response.data.title;
                this.passwordModalActive=false
                 this.loading=false;

                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;

                }); 
        },

        async validate_report_data_link(){
             this.loading=true;
             const url = this.apiurl + "validate_report_data_link?uuid="+this.$route.params.uuid
             
             //return for the async await
               await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',},
            }).then(response => {
                
                this.message = response.data.message
                this.password_required = response.data.password_enabled;
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;

                }); 

                return
        
        },
        

        //initial load method, with async methods so each function waits for the previous one to finish
        async initialLoad() {
              await this.validate_report_data_link()

            if (this.password_required == false){
                this.get_report_data_for_link(this.password)

            }
            else{
                this.passwordModalActive = true
            }
        },
        

        //if there is an event for a graph to update its range, will update all graphs ranges. 
        relayout_graphs(payload){
            //console.log("changing layout ranges")
            //console.log(payload)
            this.charts.forEach(chart => {
                if ( "xaxis.autorange" in payload) {
                   
                    chart.layout.xaxis.autorange = true
                }
                else if ("xaxis.range[0]" in payload){
                      chart.layout.xaxis.autorange = false
                       chart.layout.xaxis.range = [payload["xaxis.range[0]"],payload["xaxis.range[1]"]]
                }

                     if ( "yaxis.autorange" in payload) {
                   
                    chart.layout.yaxis.autorange = true
                }
                else if ("yaxis.range[0]" in payload){
                      chart.layout.xaxis.autorange = false
                     chart.layout.yaxis.range = [payload["yaxis.range[0]"],payload["yaxis.range[1]"]]
                }
            
                //console.log(chart.layout)
            });

        },

        get_point_summary_details(description){
            if (description == "# of Total Panels"){
                this.panelIssuesPointsTotalsModalActive = true
            }
            if (description == "# of Points Failed"){
                this.pointsFailedDetailModalActive = true
            }
             if (description == "# of Points Out of Service"){
                this.pointsOutOfServiceDetailModalActive = true
            }
            if (description == "# of Points in OPER Priority"){
                this.pointsOPERDetailModalActive = true
            }
        },
        get_alarm_summary_details(description){
            if (description == "Total Unique Alarms for period"){
                this.alarmTransitionsDetailModalActive = true
            }
            if (description == "Unresolved Enhanced Alarm Modes"){
                this.alarmUnresolvedEnhancedAlarmModesDetailModalActive = true
            }
             if (description == "Unresolved Enhanced Alarm Setpoints"){
                this.alarmUnresolvedEnhancedAlarmSetpointsDetailModalActive = true
            }
        },

        async moveCalendar(date_to_move){
            let calendar = this.$refs.calendar_chart
            await calendar.move(date_to_move)
        },
        
        submitPassword(){
            this.get_report_data_for_link(this.password)
        },

        forceRerenderCharts() {
                // Remove my-component from the DOM
                this.renderComponent = false;

                this.$nextTick(() => {
                // Add the component back in
                this.renderComponent = true;
                });
            },

             async print () {
                // Pass the element id here
                await this.$htmlToPaper('report_page');
                },

        },
    
        //Mounted Stage
        mounted() {
   this.initialLoad();   

//turn on printing mode before print
window.addEventListener('beforeprint', () => {
this.printing_mode=true;
window.dispatchEvent(new Event('resize'));
});

//turn off printing mode after print
window.addEventListener('afterprint', () => {
this.printing_mode=false;
 window.dispatchEvent(new Event('resize'));
});



    },
   

   watch: {
    columns: function (val) {
        //force resize event to update repsonsizeness of charts when new data is loaded
   window.dispatchEvent(new Event('resize'));
    },

    //changing calendar automatically after data change, wait for DOM to update then move calendar on next tick
    latest_completed_date: function (val) {
        this.$nextTick(function () {
              this.moveCalendar(val)
            })
      
    },


   }
 

      };
      

     
  </script>
  
  
  <style scoped>

@media print {
    .vertical-printing{
        display : block;
        width:100%;
    margin-left: auto;
    margin-right: auto;
    }

    .navlogo{
        width:150px;
    }

    .report_create_date{
        display: none;
       
    }

    .report_created_date_printing{
    text-align: end;
    font-size: 1.2rem;
    display: block;
    }

/*div { border: 1px solid black;}*/ /*use this for borders around elements when printing*/
    html, body {
      height:100vh; 
      margin: 0 !important; 
      padding: 0 !important;
      overflow: hidden;
    }


           .section{
            font-size:0.8em;
            line-height:1.2;
        }
        
        .card.calendar-card{
            width:100%;
        }

        .card-content{
            padding:0.2rem;
        }

        .card-header{
            -webkit-box-shadow: none; 
            box-shadow: none;
        }
        .card-header-title {
            padding-bottom:0rem;
        }

    .card{
        max-width:calc(100vw - 50px);
        -webkit-box-shadow: none; 
        box-shadow: none;
    }

    .b-table{
        width:calc(100vw - 50px);
    }

     .pagebreak { 
        page-break-after: always;
     }
}

    a{
            color: #009999;
    }
@media screen{
    
    .report_created_date_printing{
            display:none;
    }

        .section{
            font-size:0.8em;
            line-height:1.2;
        }
        
        .card.calendar-card{
            width:100%;
        }

        .card-content{
            padding:0.2rem;
        }

        .card-header{
            -webkit-box-shadow: none; 
            box-shadow: none;
        }
        .card-header-title {
            padding-bottom:0rem;
        }

    .card{
        max-height:500px;
        -webkit-box-shadow: none; 
        box-shadow: none;
    }

    .b-table{
    max-height: 400px;
    overflow-y: auto;
    }

    .column.is-centered {
    display: flex;
    flex-wrap: wrap;
    align-content: center; /* used this for multiple child */
    align-items: center; /* if an only child */
        justify-content: center;
    }
}
.navbar-item {
  display: flex;
    color: white;
}

.navbar,
.navbar-menu,
.navbar-start,
.navbar-end {
  align-items: stretch;
  display: flex;
  padding: 0;
  
}

.navbar-menu{
  flex-grow: 1;
  flex-shrink: 0;
    background-image: linear-gradient(to right,#009999, #000028, #000028);
    color: white;
  
}
.navbar-start{
  justify-content: flex-start;
  margin-right: auto;
  
}
.navbar-end{
  justify-content: flex-end;
  margin-left: auto;
}

.modal-card, .modal-content {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: auto;
}
  
.hero-body, .section {
    padding-top: 0.1rem;
}

  .navbar.is-primary {
    background-image: linear-gradient(to right,#009999, #000028, #000028);
    color: white;
}

     .navbar{
        height:0.1em;
        }
       .navtitle {
            position: absolute;
            font-size:2em;
            width: 100%;
            left: 0;
            text-align: left;
            margin: auto;
            margin-top: 0em;
            padding-left: 0.5em;
        }
            
        
        .loading {
            position: absolute;
            font-size:1em;
            width: 100%;
            size: 10%;
         
            left: 0;
            text-align: center;
            margin: auto;
            margin-top: -0.2em;
        }
  
      .column.scroll {
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: wrap;
  
      
      }
      
      .level-item {
        flex-shrink: 1;
        padding-right: 10px;
        }
        
      .field.extra-space {
        padding-right: 30px;
        }
        
      .search-result-item {
        font-size:0.8em;
        }

       .navbar-text {
            position: absolute;
            font-size:2em;
            width: 100%;
            left: 0;
            text-align: left;
            margin: auto;
            margin-top: -0.4em;
            padding-left: 1em;
        }
        
        .loading {
            position: absolute;
            font-size:1em;
            width: 100%;
            size: 10%;
           padding-top: 4px;
            left: 0;
            text-align: center;
            margin: auto;
        }
       
               
        label.stack{  
            width:200px;       

            display:inline-block;    
            vertical-align:middle; 
        }

    .button.is-primary {
       background-color:#000028;
        color:white;
        }       
       
       .button.is-primary:hover{
         background-color:#000028;
           color:white;
       }
       

       .button.is-primary:active{
         background-color:#002949;
           color:white;
       }
             
        input:focus{
       outline-color: #002949;
       border-color: #000028;
       shadow-color: #000028;
      box-shadow: 0 0 3px #000028;
       }

       select:focus {
       outline-color: #002949 !important;;
       border-color: #000028 !important;;
       shadow-color: #000028;
      box-shadow: 0 0 3px #000028 !important;;
      }
       
             
  </style>